var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "514.000000pt",
    height: "514.000000pt",
    viewBox: "0 0 520.000000 520.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3230 4253 c-290 -43 -504 -118 -710 -246 -607 -379 -916 -1097 -770 -1794 122 -584 558 -1077 1119 -1263 178 -60 293 -80 479 -87 324 -12 572 43 852 188 160 83 287 176 415 304 257 257 416 561 481 920 25 139 25 431 0 570 -133 731 -705 1292 -1428 1399 -96 15 -367 20 -438 9z m405 -308 c141 -22 259 -60 390 -124 400 -196 678 -552 765 -983 67 -327 12 -679 -151 -963 -216 -377 -582 -632 -1004 -700 -118 -20 -327 -19 -446 1 -290 48 -550 184 -764 399 -207 207 -340 460 -391 745 -23 127 -23 353 0 480 81 451 384 844 798 1034 93 43 251 92 353 110 107 19 338 20 450 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3270 3448 l0 -123 -60 -28 c-35 -16 -85 -52 -119 -85 -181 -178 -189 -461 -18 -648 83 -91 184 -139 323 -153 67 -7 91 -14 119 -35 47 -36 67 -78 67 -138 -1 -60 -35 -118 -84 -145 -50 -26 -128 -23 -171 7 -39 27 -77 85 -77 119 0 20 -4 21 -150 21 l-150 0 0 -32 c1 -143 121 -320 260 -385 l60 -28 0 -123 0 -123 148 3 147 3 3 121 3 120 55 27 c107 53 198 161 236 280 22 71 26 190 8 258 -52 195 -250 349 -448 349 -21 0 -58 10 -82 23 -153 76 -97 312 74 311 28 0 65 -8 83 -17 40 -21 83 -83 83 -119 l0 -28 153 0 154 0 -8 59 c-22 157 -117 291 -255 359 l-53 26 -3 120 -3 121 -147 3 -148 3 0 -123z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 3420 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2560 l0 -150 645 0 645 0 0 150 0 150 -645 0 -645 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 1700 l0 -150 465 0 465 0 0 150 0 150 -465 0 -465 0 0 -150z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney1);
export default __webpack_public_path__ + "static/media/money_1_.62f0405a1fca10356209b30aaeb34b21.svg";
export { ForwardRef as ReactComponent };